// extracted by mini-css-extract-plugin
export default {"border":"ConsentStyle_border__ZOyn5"};